import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Report from "@/pages/Report";
import Dashboard from "@/pages/Dashboard";
import Consultation from "@/pages/Consultation";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import Plans from "@/pages/Plans";
import Policies from "@/pages/Policies";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/assess" element={<Assessment />} />
      <Route path="/results" element={<Results />} />
      <Route path="/report/:reportId" element={<Report />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/consultation" element={<Consultation />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/plans" element={<Plans />} />
      <Route path="/policies" element={<Policies />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
